// extracted by mini-css-extract-plugin
module.exports = {"link":"link--51398c","link__text":"link__text--aef88a","link_extended":"link_extended--93e527","link__icon":"link__icon--53c5bf"};